<template>

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll" >

        <!-- SIDEBAR -->
        <SidebarBody/>

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" style="padding: 10px ">

                <div class="row mb-32 gy-0 dash-top">

                    <!-- POSTS -->
                    <div class="col-12">

                        <div class="row g-32">

                            <div class="col-12 col-xl-8" style=" padding-bottom: 500px;">

                                <!-- <h2 class="mm-none">Bookmarks</h2> -->
                                <h2 class="dd-none" style="margin-top: -40px;"></h2>

                                <div class="col-12" style="margin-bottom: 20px;" v-for="(book, index) in bookmarkList" :key="'number'+index">

                                                <div class="card hp-card-4" v-if="book.isLoading">
                                                <div class="card-body">
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                    <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                    <br> 

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                    </div>

                                                    <br> 

                                                    <div class="mm-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                    </div>

                                                    <div class="dd-none">
                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                    </div>

                                                    <br> 
                                                    
                                                </div>
                                                </div>

                                                <div class="card hp-card-4" v-else>
                                                    <div class="card-body" >
                                                        
                                                        <div class="row">

                                                            <div class="col" >

                                                                <i class="hp-text-color-dark-0 ri-2x ri-more-line" style="position: absolute; top: 24px; right: 20px; cursor: pointer;" data-bs-toggle="dropdown" ></i>

                                                                <ul class="dropdown-menu " style="cursor: pointer;">

                                                                    <li @click="copy(book.id)" class="toast-btn" data-id="liveToast" id="liveToastBtn">
                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" >

                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-file-copy-line" style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -7px; margin-left: 10px;">Copy link</span>
                                                                        </div>
                                                                    </li>

                                                                    <li >
                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" @click="share(book.id)"> 
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-share-line" style="font-size: 20px;"></i>
                                                                            </span>
                                                                            
                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Share</span>
                                                                        </div>
                                                                    </li>

                                                                    <li>
                                                                        <hr class="dropdown-divider">
                                                                    </li>

                                                                    <li data-bs-toggle="modal" data-bs-target="#reportModal" @click="reportClick(book.id)">
                                                                        <div class="dropdown-item text-danger"
                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                            <span class="submenu-item-icon">
                                                                                <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                    style="font-size: 20px;"></i>
                                                                            </span>

                                                                            <span
                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                        </div>
                                                                    </li>


                                                                </ul>

                                                                <div class="row align-items-center" >
                                                                    <div class="w-auto px-0" @click="profileClick(book.userId, book.userName)" style="cursor: pointer;">
                                                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                                                            <img :src="book.profilePic"  class="hp-img-cover" style="width: 48px; height: 48px; background-color: black; object-fit: cover; ">
                                                                        </div>
                                                                    </div>

                                                                    <div class="w-auto ms-8 px-0 mt-12" @click="profileClick(book.userId, book.userName)" >
                                                                        <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM" >{{ book.fullName }} 
                                                                            <span v-if="book.userType == 'model'">
                                                                                <img src="@/assets/img/check-circle.png" alt="" style="width: 12px; height: 12px; margin-left: 2px; margin-top: -3px;" > 
                                                                            </span>

                                                                            <span v-if="book.sexuality == 'gay'">
                                                                                <img src="@/assets/img/gay.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                            </span>

                                                                            <span v-else-if="book.sexuality == 'lesbian'">
                                                                                <img src="@/assets/img/lesibian.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                            </span>

                                                                            <span v-else-if="book.sexuality == 'bisexual'">
                                                                                <img src="@/assets/img/bisexual.png" alt="" style="width: 12px; height: 12px; margin-left: 5px; margin-top: -3px;">
                                                                            </span>

                                                                        </span>
                                                                        <p class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">@{{ book.userName }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <p v-if="book.previewUrl == ''" style="margin-top: 30px; margin-bottom: -5px;">{{ book.caption }}</p>
                                                            <p v-else style="margin-top: 10px; margin-bottom: -5px;">{{ book.caption }}</p>

                                                            

                                                        </div>

                                                    </div>

                                                    <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="book.postType == 'paid' && book.isPaid && book.isSubscribed"
                                                        style="cursor: pointer; ">

                                                        <div v-if="book.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="book.toggler = !book.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="book.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #008080;">

                                                                <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                    :src="book.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                        :src="book.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                        :src="book.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                        :src="book.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                            :src="book.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[3].type.startsWith('image')"
                                                                            :src="book.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                            :src="book.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>
                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[3].type.startsWith('image')"
                                                                            :src="book.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                book.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="book.previewUrl != ''" :src="book.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="book.toggler = !book.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="book.toggler" :sources="book.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else-if="book.postType == 'paid' && !book.isPaid && book.isSubscribed" style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="book.previewUrl != ''" :src="book.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="book.toggler = !book.toggler">

                                                        <div v-if="book.previewUrl != '' && book.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #008080; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="book.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ book.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="book.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ book.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="ppvClick(book)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Unlock post for &#8358; {{ book.priceD }}</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="book.toggler" :sources='book.previewUrl2' />

                                                        

                                                    </div>

                                                    <div v-else-if="book.isSubscribed || book.isOwner || book.postType == 'freex'"
                                                        style="cursor: pointer; ">

                                                        <div v-if="book.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="book.toggler = !book.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="book.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #008080;">

                                                                <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                    :src="book.mediaList[0].url" alt="Baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="book.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 2"
                                                                style=" width: 100%;  height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                        :src="book.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                        :src="book.mediaList[1].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                        :src="book.mediaList[0].url" alt="Baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                            :src="book.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[3].type.startsWith('image')"
                                                                            :src="book.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="book.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[0].type.startsWith('image')"
                                                                            :src="book.mediaList[0].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[1].type.startsWith('image')"
                                                                            :src="book.mediaList[1].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>
                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="book.mediaList[2].type.startsWith('image')"
                                                                            :src="book.mediaList[2].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="book.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="book.mediaList[3].type.startsWith('image')"
                                                                            :src="book.mediaList[3].url" alt="Baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="book.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                book.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="book.previewUrl != ''" :src="book.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="book.toggler = !book.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="book.toggler" :sources="book.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="book.previewUrl != ''" :src="book.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="book.toggler = !book.toggler">

                                                        <div v-if="book.previewUrl != '' && book.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #008080; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="book.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ book.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="book.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ book.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="subClick2(book)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="book.toggler" :sources='book.previewUrl2' />

                                                        

                                                    </div>

                                                </div>

                                                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                        <div  style="display: flex; justify-content: center; align-items: center;">

                                                            <div >

                                                                <div v-if="book.isLiked" :id="book.idD+'like'" @click="likeClick(book.idD+'like', index, book)" class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                </div>

                                                                <div v-else :id="book.idD+'like'" @click="likeClick(book.idD+'like', index, book)" class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                </div>

                                                            </div>

                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                {{ book.likeCount }}
                                                            </span>

                                                            <div v-if="book.isBookmarked" :id="book.idD+'book'" @click="bookClick(book.idD+'book', index, book)" class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                            </div>

                                                            <div v-else :id="book.idD+'book'" @click="bookClick(book.idD+'book', index, book)" class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                            </div>

                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                {{ book.bookmarkCount }}
                                                            </span>

                                                            <div v-if="book.commentCount > 0" @click="commentClick(book, index)" data-bs-toggle="modal" data-bs-target="#comments"  class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                                <i class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                            </div>

                                                            <div v-else @click="commentClick(book, index)" data-bs-toggle="modal" data-bs-target="#comments"  class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                <i class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                            </div>

                                                            

                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                {{ book.commentCount }}
                                                            </span>

                                                        </div>

                                                        <div>

                                                            <button @click="tipClick(book)" class=" hp-cursor-pointer btn btn-sm btn-outline-primary rounded-circle" data-bs-toggle="modal" data-bs-target="#sendTip" style="padding: 5px 10px; "  v-if="!book.isOwner">
                                                                <span >&#8358;</span>
                                                                
                                                            </button>

                                                        </div>

                                                    </div>
                                                    
                                                </div>
                                </div>

                                <div id="emptyAllBook2"
                                            style="width:100%; display: flex; justify-content: center; align-items: center;">

                                    <InfiniteLoading @infinite="handleInfinite" class="spinner">

                                    </InfiniteLoading>

                                </div>

                                <div style="margin-top: 200px; margin-bottom: 400px; display: flex ; visibility: hidden;  justify-content: center; align-items: center; flex-direction: column; width: 100%;" id="emptyAllBook">
                                    <p class="hp-badge-text">No bookmarks yet...</p>
                                </div>

                            </div>

                            <!-- SUGGESTIONS -->
                            <div class="col-12 col-xl-4">

                                <SuggestionsBody/>

                            </div>
                            

                        </div>

                    </div>

                    
                </div>

                <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>
    

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>


    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- SUCCESS2 -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal2">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText2 }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS2">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- MEDIA GALLERY -->
        <div class="modal fade" id="mediaGallery" tabindex="-1" aria-labelledby="mediaGalleryLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h5 class="modal-title">Media gallery ( @{{ modelUsername }} )</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button>
                    </div>

                    <div class="modal-body" style="margin-top: -30px;">

                        <div v-if="mediaUrl != ''" style="display: flex; justify-content: center; align-items: center; margin-bottom:10px ;">

                                <video controls controlsList="nodownload" oncontextmenu="return false;" v-if="mediaType.startsWith('video')"  class="shm">
                                    <source :src="mediaUrl" type="video/mp4" >
                                    <source :src="mediaUrl" type="video/ogg" >
                                    <source :src="mediaUrl" type="video/webm" >
                                    <source :src="mediaUrl" type="video/3gp" >
                                    <source :src="mediaUrl" type="video/quicktime" >
                                    Your browser does not support the video tag.

                                </video>

                                <img :src="mediaUrl" alt="" v-else class="shm" style="object-fit: cover;">

                                

                        </div>

                        <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0" ></div>

                        <div class="d-flex align-items-center justify-content-center" style="flex-wrap: wrap;">

                            <!-- dupli img-->
                            <div v-for="(media, index) in mediaList" :key="index" style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                <div v-if="media.type.startsWith('image')" @click="playMedia(media)">
                                    <img :src="media.url" alt="" style="width: 90px; height: 90px; object-fit: cover; border-radius: 5px; cursor: pointer;"  >

                                    <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{ fileSizeFormat(media.size) }} </p>
                                </div>

                                <div v-else style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                    <div @click="playMedia(media)" >
                                        <video style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover; position: relative;">
                                            <source :src="media.url" type="video/mp4" >
                                            <source :src="media.url" type="video/ogg" >
                                            <source :src="media.url" type="video/webm" >
                                            <source :src="media.url" type="video/3gp" >
                                            <source :src="media.url" type="video/quicktime" >
                                            Your browser does not support the video tag.

                                        </video>

                                        <i  class="hp-text-color-dark-0 position-absolute ri-2x ri-play-circle-fill" style="color: #fff; top: 25%; left: 35%; cursor: pointer;"></i>

                                        <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{ fileSizeFormat(media.size) }} </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        
                    </div>
                    
                </div>
            </div>
        </div>

        <!-- SHOW -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 9999;" class="loadingModalBg" ref="showModal">
            <div class="col-12 col-xl-12 shx">
                <div class="card hp-card-6">
                    <div class="card-body" style="position: relative;">

                        <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center" style="position:absolute; top:10px; right: 10px;" @click="closeShow">
                                <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                        </button>

                        <div class="row">

                            <h4 style="text-align: center;">{{mediaName}}</h4>

                            <div style="display: flex; justify-content: center; align-items: center;">

                                <video controls v-if="mediaType.startsWith('video')"  class="shm">
                                    <source :src="mediaUrl" type="video/mp4" >
                                    <source :src="mediaUrl" type="video/ogg" >
                                    <source :src="mediaUrl" type="video/webm" >
                                    <source :src="mediaUrl" type="video/3gp" >
                                    <source :src="mediaUrl" type="video/quicktime" >
                                    Your browser does not support the video tag.

                                </video>

                                <img :src="mediaUrl" alt="" class="shm" v-else>

                                

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- UNLOCK1 -->
        <div class="modal fade" id="unlock1" tabindex="-1" aria-labelledby="unlock1Label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Subscribe</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <p class="hp-p1-body">Subscribe to gain full access to content from [model name]</p>

                        <div data-bs-toggle="modal" data-bs-target="#unlock2" class="d-flex justify-content-between align-items-center" style="padding: 15px 20px 15px 20px; margin: 30px 10px 15px 10px; background-color: #FF7F80; border-radius: 20px; cursor: pointer;">

                            <span class="hp-badge-text" style="color: #fff;">1 month</span>
                            <span class="hp-badge-text" style="color: #fff;"><span>&#8358;</span>10,000</span>

                        </div>

                        <div data-bs-toggle="modal" data-bs-target="#unlock2" class="d-flex justify-content-between align-items-center" style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #FFC212; border-radius: 20px; cursor: pointer;">

                            <span class="hp-badge-text" style="color: #fff;">3 months</span>
                            <span class="hp-badge-text" style="color: #fff;"><span>&#8358;</span>30,000</span>

                        </div>

                        <div data-bs-toggle="modal" data-bs-target="#unlock2" class="d-flex justify-content-between align-items-center" style="padding: 15px 20px 15px 20px; margin: 10px 10px 15px 10px; background-color: #C903FF; border-radius: 20px; cursor: pointer;">

                            <span class="hp-badge-text" style="color: #fff;">6 months</span>
                            <span class="hp-badge-text" style="color: #fff;"><span>&#8358;</span>50,000</span>

                        </div>
                        
                    </div>

                    <!-- <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger">Close</button>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- COMMENTS -->
        <div class="modal fade" id="comments" tabindex="-1" aria-labelledby="commentsLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">{{ commentCount }} Comments</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button>
                    </div>

                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0" ></div>

                    <div class="modal-body" style="margin-top: -25px;">

                        <div id="comDiv"></div>

                        <div class="col-12" v-for="(com, index) in comments" :key="index">

                            <div class="row">
                                <div class="col-12" style="margin-bottom: 20px;" >
                                    <div style="justify-content: flex-start; display: flex; align-items: flex-start; width: 100%;">
                                        <div class="w-auto px-0" @click="profileClick(com.userId, com.userName)" style="cursor: pointer;" data-bs-dismiss="modal">
                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 38px; height: 38px; ">
                                                <img :src="com.profilePic"  class="hp-img-cover" style="width: 38px; height: 38px; background-color: black; object-fit: cover; ">
                                            </div>
                                        </div>

                                        <div class="w-auto ms-8 px-0 mt-4" style="width: 100%;">
                                            <p class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 mt-4 titleM" style="font-size: 14px;"> {{ com.name }}  </p>
                                            <p style="font-size: 12px; margin-top: -5px; width: 100%; word-break: break-all;" class=" fw-normal hp-text-color-dark-30"> {{ com.comment }} </p>

                                            <p style="font-size: 9px; font-style: italic;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">{{ com.date }}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div v-if="commentCount == 0" style="margin-top: 50px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <p class="hp-badge-text">No comments yet...</p>
                        </div>

                        <div v-if="commentCount > 20" style="margin-top: 0px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <button data-bs-dismiss="modal" class="btn btn-sm btn-primary" @click="postClick(postId)">Load more</button>
                        </div>

                    
                    </div>

                    <form @submit.prevent="postComment" style="width: 100%; padding: 20px;">

                        <div
                            style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 0px;">

                            <div style="width: 100%; margin-right: 10px;">

                                <textarea style="line-height: 20px; padding-top: 10px;" name="description"
                                    v-model="commentInput" maxlength="300" class="form-control" rows="3"
                                    placeholder="Type comment here..." required></textarea>
                            </div>

                            <button class="btn btn-sm btn-icon-only rounded-circle btn-primary" id="commentBtn">
                                <i class="hp-text-color-dark-0 iconly-Light-Send"></i>
                            </button>

                            <!-- <button class="btn btn-sm btn-primary" style="color: #fff;" >Send</button> -->

                        </div>

                    </form>

                    
                </div>
            </div>
        </div>

        <!-- SEND TIP -->
        <div class="modal fade" id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <div class="w-auto px-0" >
                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                <img :src="modelProfilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                            </div>
                        </div>

                        <h4 style="text-align: center; width: 100%" class="modal-title">Send Tip</h4>

                        <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            ></button>
                        
                    </div>

                    

                    <div class="modal-body" style="margin-top: -40px;">

                        <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                        <form @submit.prevent="sendTip">

                            <div class="mb-24" style="margin-top: 30px;">

                                <label for="displayName" class="form-label">Amount</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">&#8358;</span>
                                    <input type="number" class="form-control" placeholder="0 to 50,000" aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                                </div>

                            </div>

                            <div class="mb-24">

                                <label for="displayName" class="form-label">Message</label>
                                <textarea name="description" id="description" class="form-control" rows="4"  placeholder="Type a message here..."  style="line-height: 20px; padding-top: 10px;" v-model="message" maxlength="500"></textarea>

                            </div>

                            <div class="divider mt-18 mb-16"></div>

                            

                            <div class="modal-footer d-flex justify-content-center">
                                
                                <button class="btn btn-primary">Confirm</button>
                            </div>

                        </form>

                        
                        
                    </div>

                    
                </div>
            </div>
        </div>

        <!-- PPV -->
         <div class="modal fade" id="ppv" tabindex="-1" aria-labelledby="ppvLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Pay &#8358; {{ppvPost.priceD}} </h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <!-- <p class="hp-p1-body">Pay <strong></strong> to gain full access to this post </p> -->
                        
                        <div class="mb-24" style="margin-top: 10px;">

                            <label for="displayName" class="form-label">Password</label>
                            <input type="password" class="form-control" placeholder="*********" aria-label="Username"
                                    aria-describedby="basic-addon1" required v-model="password">

                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" @click="ppv">Pay</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- COPY TOAST -->
        <div class="position-fixed bottom-0 end-0 p-16" style="z-index: 99">
            <div data-id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" id="toastDiv" style="background-color: #e8def7; padding: 10px;">
                <div class="toast-header" style="background-color: #e8def7;">
                    
                    <strong class="me-auto">Baesnap</strong>
                    <small>1 second ago</small>
                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>

                <div class="toast-body">
                    {{toastMessage}}
                </div>
            </div>
        </div>

        <!-- REPORT -->
        <div class="modal fade" id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="centeredBackdropLabel">Report</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <form @submit.prevent="report">

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason1" checked v-model="reportReason" value="Violates Baesnap Terms of Service">
                                <label class="form-check-label" for="reportReason1">
                                    Violates Baesnap Terms of Service
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason2" v-model="reportReason" value="Contains copyrighted material (DMCA)">
                                <label class="form-check-label" for="reportReason2">
                                    Contains copyrighted material (DMCA)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason3" v-model="reportReason" value="Child Sexual Abuse Material (CSAM)">
                                <label class="form-check-label" for="reportReason3">
                                    Child Sexual Abuse Material (CSAM)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason4" v-model="reportReason" value="Report Spam">
                                <label class="form-check-label" for="reportReason4">
                                    Report Spam
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason5" v-model="reportReason" value="Report Abuse">
                                <label class="form-check-label" for="reportReason5">
                                    Report Abuse
                                </label>
                            </div>

                            <div class="mb-24" style="margin-top: 30px;">
                                <label for="orderDetails" class="form-label"> Message <span class="text-danger me-4">*</span> </label>
                                <textarea name="orderDetails" id="orderDetails" class="form-control" rows="4" placeholder="Type here..." maxlength="300" required v-model="reportMessage" style="line-height: 20px; padding: 10px;"></textarea>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Report</button>
                            </div>

                            
                        </form>
                    </div>

                    
                </div>
            </div>
        </div>


</template>

<style scoped>

    .shx{
        width: 1000px;   
    }

    .shm{
        max-width: 100%;
        max-height: 500px;
        object-fit: cover;
    }

    @media only screen and (max-width: 666px){

        .shx{
            width: 350px;
            
        }

        .shm{
            max-width: 100%;
            max-height: 700px;
            object-fit: cover;
        }

    }

</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import SuggestionsBody from '@/components/SuggestionsBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";
    import FsLightbox from "fslightbox-vue";
    import LvSkeleton from "lightvue/skeleton";
    import LvCodeLoader from 'lightvue/skeleton/preset/CodeLoader';

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc, Timestamp } from "firebase/firestore"; 
    import {getAuth, onAuthStateChanged, signOut, EmailAuthProvider, reauthenticateWithCredential} from "firebase/auth"
    import { db } from '@/firebase';
    import axios from 'axios';
    import { MD5 } from 'md5-js-tools';

    export default {

        components: {
            SidebarBody,
            HeaderBody,
            SuggestionsBody,
            FooterBody,
            InfiniteLoading,
            FsLightbox,
            LvSkeleton,
            LvCodeLoader,
        },

        data(){

            return{
                loadingText:"",
                errorText: "",
                successText: "",
                successText2: "",
                postIdList: [],
                bookmarkList: [],

                modelUsername: "",
                mediaList: "",
                mediaName: "",
                mediaSize: "",
                mediaType: "",
                mediaUrl: "",

                commentPic: "",
                commentCount: "",
                comments: [],
                commentInput: "",
                postIndex: "",

                likeSpamList:[],
                bookSpamList:[],

                tip: "",
                modelId: "",
                modelProfilePic: "",
                modelName: "",
                modelEmail: "",
                message: "",

                tipPostId: "",

                cModelId:"",

                ppvPost: "",
                password: "",

                lastDocSnapshot: null,

                postId: "",
                toastMessage: "",
                reportReason: "Violates Baesnap Terms of Service",
                reportMessage: "",
                rPostId: "",
                reportCount: 0,

                userType: "",
                upline: "",
                uplineUserId: "",
                refCut: "",
                dateJoined: "",
                sexuality: "",

                videoObserver: null
            }

        },

        mounted(){

            document.body.style.overflowY = 'scroll';
            document.body.style.padding = '0px';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Bookmarks';

            document.getElementById("collectionN").classList.add("active");
            document.getElementById("collectionN").classList.add("arrow-active");
            
            document.getElementById("collectionN2").classList.add("active");
            document.getElementById("collectionN2").classList.add("arrow-active");

            this.getRefCut();
            
            this.videoObserver = new MutationObserver(() => {
                this.hideDownloadButtons()
            })

            this.videoObserver.observe(document.body, {
                childList: true,
                subtree: true
            })
            
        },

        beforeUnmount(){
            if (this.videoObserver) {
                this.videoObserver.disconnect()
            }
        },

        methods:{

            async getRefCut(){
                const userRef = doc(db, "AdminInfo", "info");
                const userSnap = await getDoc(userRef);
                let rc = userSnap.data().refCut;
                this.refCut = Number(rc);

            },

            hideDownloadButtons() {
                document.querySelectorAll('.fslightbox-container video').forEach(video => {
                    video.setAttribute('controlsList', 'nodownload')
                    video.setAttribute('disablePictureInPicture', '')
                    video.oncontextmenu = () => false
                })
            },

            closeS2() {
                this.$refs.successModal2.classList.remove("bg-active");
                //this.$router.go();
            },

            postClick(postId){

                this.$router.push({ name: 'post', params: { id: postId } });
                return;

            },

            reportClick(postId){
                this.rPostId = postId;
            },

            showToast(){
                $(".toast").each(function () {
                    let eachItem = $(this), eachItemId = eachItem.data("id");

                    if (eachItemId) {
                        new bootstrap.Toast($(this)).show();
                    }
                });
            },

            async report(){

                this.reportCount++

                if(this.reportCount > 4){
                    return;
                }

                this.loadingText = "Reporting post";
                this.$refs.loadingModal.classList.add("bg-active");

                //add report
                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                const auth = getAuth();

                await addDoc(collection(db, "UserReports"), {
                        
                    title: this.reportReason,
                    message: this.reportMessage,
                    postId: this.rPostId,
                    status: "pending",
                    userId: auth.currentUser.uid,
                    fullName: sessionStorage.getItem("fullName"),
                    email: sessionStorage.getItem("email"),
                    username: sessionStorage.getItem("userName"),
                    profilePic: sessionStorage.getItem("profilePic"),
                });

                this.toastMessage = "Post reported successfully!";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.showToast();

            },

            share(postId){
                if(navigator.share){
                    navigator.share({
                        text: "Check out my post on Baesnap",
                        url: "https://app.baesnap.com/post/"+postId,
                        title: "Baesnap | Post"
                    })
                }
                else{
                        navigator.clipboard.writeText("https://app.baesnap.com/post/"+postId)
                }
            },

            copy(postId){
                this.toastMessage = "Link copied successfully!"
                let link = "https://app.baesnap.com/post/"+postId;
                navigator.clipboard.writeText(link);
                this.showToast(); 

            },

            subClick(book){

                sessionStorage.setItem("otherId", book.userId);
                this.$router.push({name: 'other-profile'});
                return;

            },

            subClick2(book){

                sessionStorage.setItem("otherId", book.userId);
                this.$router.push({name: 'sub-pay'});
                return;

            },

            tipClick(book){

                this.modelId = book.userId;
                this.modelName = book.fullName;
                this.modelUsername = book.userName;
                this.modelProfilePic = book.profilePic;
                this.modelEmail = book.email;
                this.tipPostId = book.id;

            },

            async sendTip(){

                let balance, newBalance, uFullname, uEmail, uProfilePic, uUsername;

                this.loadingText = "Sendind tip to @"+this.modelUsername+"...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                if(this.tip > 500000){
                    this.errorText = "Tips can not be larger than ₦ 500,000";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                //check balance
                if(auth.currentUser.uid == this.modelId){
                    this.errorText = "You can not send a tip to yourself...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if(userSnap.exists()){
                    balance = userSnap.data().balance;
                    uUsername = userSnap.data().displayId;
                    uFullname = userSnap.data().name;
                    uProfilePic = userSnap.data().profilePic;
                    uEmail = userSnap.data().email;

                    if(balance < this.tip){
                        this.errorText = "Insufficient balance. Please top up your account and try again.";
                        this.$refs.errorModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else{
                    this.$router.push({name: 'sign-in'});
                    return;
                }

                newBalance = balance - this.tip;

                await updateDoc(userRef, {
                    balance: newBalance,
                });

                const modelRef = doc(db, "Users", this.modelId);
                const modelSnap = await getDoc(modelRef);
                if(modelSnap.exists()){
                    this.dateJoined = modelSnap.data().dateJoined.seconds;
                    this.upline = modelSnap.data().upline;
                    this.sexuality = modelSnap.data().sexuality;
                    this.userType = modelSnap.data().type;
                }

                const q = query(collection(db, "Users"), where("refCode", "==", this.upline));
                const idSnapshot = await getDocs(q);
                if(idSnapshot.docs.length > 0){
                    idSnapshot.forEach((doc) => {
                        this.uplineUserId = doc.id;
                    });

                }

                await updateDoc(modelRef, {
                    earnings: increment(this.tip),
                    tipBalance: increment(this.tip)
                });

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs

                //update user transactions
                await addDoc(collection(db, "UserTrans"),{
                    idD: "FBW"+Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdrawal",
                    title: "Sent tip",
                    description: " Sent a tip of ₦ "+this.tip+ " to @"+this.modelUsername,
                    amount: this.tip,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: auth.currentUser.uid,
                    fullName: this.modelName,
                    username: this.modelUsername,
                    profilePic: this.modelProfilePic,
                });

                //update model transactions
                await addDoc(collection(db, "UserTrans"),{
                    idD: "FBD"+Math.floor(1000000 + Math.random() * 9000000),
                    type: "Deposit",
                    title: "Received tip",
                    description: this.message,
                    amount: this.tip,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: this.modelId,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                });

                // NOTIFICATION
                if( this.modelId != auth.currentUser.uid){

                    const notiRef = doc(db, "Users", this.modelId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime()/1000;
                    let secs = 10000000000 / mSecs
                    await addDoc(collection(db, "UserNoti"),{
                        category: "Tips",
                        description: "Sent you a tip of ₦ "+this.tip,
                        ownerId: this.modelId,
                        userId: auth.currentUser.uid,
                        username: uUsername,
                        fullName: uFullname,
                        profilePic: uProfilePic,
                        email: uEmail,
                        date: serverTimestamp(),
                        postId: this.tipPostId,
                        dateN: secs
                    });

                }


                //REFF
                //check ref endDate
                let dateJoinedMili = Number(this.dateJoined) * 1000;
                let todayMili = Timestamp.now().seconds * 1000;

                let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

                if(Number(refDays) < 365 && this.upline != ""){

                    if(this.uplineUserId == auth.currentUser.uid){
                        $('#sendTip').modal('hide');
                        this.successText2 = "Tip sent successfully";
                        this.$refs.successModal2.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }

                    //update upline ref balance
                    let mRefCut = this.refCut/100;
                    let refAmount = Number(this.tip) * mRefCut;

                    const usersRef = doc(db, "Users", this.uplineUserId);
                    await updateDoc(usersRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    //update upline ref user
                    const refUserRef = doc(db, "Referrals", this.modelId);
                    await updateDoc(refUserRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    let mSecs = Timestamp.now().seconds;
                    let secs = 10000000000 / mSecs;
                    
                    //update upline refTrans
                    await addDoc(collection(db, "RefTrans"), {
                        type: "Deposit",
                        refAmount: refAmount,

                        fullName: this.modelName,
                        userName: this.modelUsername,
                        profilePic: this.modelProfilePic,
                        email: this.modelEmail,
                        userType: this.userType,
                        sexuality: this.sexuality,
                        userId: this.modelId,
                        timeStamp: serverTimestamp(),
                        timeStampN: secs,

                        status: "successful",
                        ownerId: this.uplineUserId
                    });

                }


                $('#sendTip').modal('hide');
                this.successText2 = "Tip sent successfully";
                this.$refs.successModal2.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            ppvClick(post){
                this.ppvPost = post;
                $('#ppv').modal('show');
            },

            ppv(){

                this.loadingText = "Authenticating...";
                this.$refs.loadingModal.classList.add("bg-active");

                
                if(this.password == ""){
                    this.errorText = "Please enter your password to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                let passwordHash = MD5.generate(String(this.password));

                const auth = getAuth();
                const user = auth.currentUser;

                if(this.ppvPost.userId == auth.currentUser.uid){
                    return;
                }

                const credential = EmailAuthProvider.credential( sessionStorage.getItem("email"), passwordHash );

                reauthenticateWithCredential(user, credential)
                .then((result) => {
                    //password correct
                    this.ppv2();

                })
                .catch((error) => {
                    //console.log(error);
                    this.errorText = "Incorrect password...";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;

                });
            },

            async ppv2(){
                let balance, newBalance, uFullname, uEmail, uUsername, uProfilePic;

                const auth = getAuth();
                this.loadingText = "Processing transaction...";

                //check balance
                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    balance = userSnap.data().balance;
                    uFullname = userSnap.data().name;
                    uUsername = userSnap.data().displayId;
                    uProfilePic = userSnap.data().profilePic;
                    uEmail = userSnap.data().email;

                    if (balance < this.ppvPost.price) {
                        this.errorText = "Insufficient balance. Please top up your account and try again.";
                        this.$refs.errorModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }
                }
                else {
                    this.$router.push({ name: 'sign-in' });
                    return;
                }

                await updateDoc(userRef, {
                    balance: increment(-this.ppvPost.price),
                    
                });

                //update model balance
                const modelRef = doc(db, "Users", this.ppvPost.userId);
                await updateDoc(modelRef, {
                    earnings: increment(this.ppvPost.price),
                    ppvBalance: increment(this.ppvPost.price),
                });

                //add to paidUsers
                await setDoc(doc(db, "UserPosts", this.ppvPost.id, "PaidUsers", auth.currentUser.uid), {});

                let mSecs = new Date().getTime() / 1000;
                let transSecs = 10000000000 / mSecs;

                //update user transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Withdrawal",
                    title: "Paid post",
                    description: " Paid to view post",
                    amount: this.ppvPost.price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: auth.currentUser.uid,
                    fullName: this.ppvPost.fullName,
                    username: this.ppvPost.userName,
                    profilePic: this.ppvPost.profilePic,
                });

                //update model transactions
                await addDoc(collection(db, "UserTrans"), {
                    idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                    type: "Deposit",
                    title: "Paid post",
                    description: "@" + uUsername + " paid to view your post",
                    amount: this.ppvPost.price,
                    method: "Baesnap Wallet",
                    date: serverTimestamp(),
                    dateN: transSecs,
                    status: "successful",
                    userId: this.ppvPost.userId,
                    
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,

                });

                // NOTIFICATION
                if (this.ppvPost.userId != auth.currentUser.uid) {

                    const notiRef = doc(db, "Users", this.ppvPost.userId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"), {
                        category: "Paid posts",
                        description: "Paid for your post",
                        ownerId: this.ppvPost.userId,
                        userId: auth.currentUser.uid,
                        username: uUsername,
                        fullName: uFullname,
                        profilePic: uProfilePic,
                        email: uEmail,
                        date: serverTimestamp(),
                        dateN: secs,
                        postId: this.ppvPost.id,
                    });

                }

                axios.post('https://api.baesnap.com/v1/new-ppv-mail', {
                    toName: this.ppvPost.fullName,
                    toEmail: this.ppvPost.email,
                    username: "@" + uUsername,
                    amount: this.ppvPost.priceD,
                    
                })
                .then(function (response) {
                    //console.log(response);
                })

                $('#ppv').modal('hide');

                this.successText = "The transaction was completed successfully. You now have full access to the post.";
                this.$refs.successModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeShow(){
                this.mediaName = "";
                this.mediaType = "";
                this.mediaUrl = "";
                this.mediaSize = "";
                this.$refs.showModal.classList.remove("bg-active");
                return;
                
            },

            profileClick(userId, userName){

                const auth = getAuth();

                if(auth.currentUser.uid == userId){
                    this.$router.push({name: 'profile'});
                    return;
                }

                sessionStorage.setItem("otherId", userId);
                this.$router.push({ name: 'other-profile', params: { id: userName } });
                return;

            },

            getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            },

            fileSizeFormat(fileSize){
                let mSize;
                if (Number(fileSize) >= 1073741824) { 
                        mSize = (Number(fileSize) / 1073741824).toFixed(2) + " GB"; 
                    }
                    else if (Number(fileSize) >= 1048576) { 
                        mSize = (Number(fileSize) / 1048576).toFixed(2) + " MB"; 
                    } 
                    else if (Number(fileSize) >= 1024) { 
                        mSize = (Number(fileSize) / 1024).toFixed(2) + " KB"; 
                    }
                    
                    return mSize;
            },

            kFormatter(num) {
                return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num);
                
            },

            timeFormat(date){

                let newFormat;

                TimeAgo.addDefaultLocale(en);
                const timeAgo = new TimeAgo('en-US');
                newFormat =  timeAgo.format(Number(date));

                return newFormat;

            },

            async getBookmarkList(){

                //get postId list
                let res = [];
                const auth = getAuth();

                const q = query(collection(db, "UserBookmarks/"+auth.currentUser.uid+"/BookmarkList"), orderBy("timeStampN"), limit(10), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];

                if (res.length > 0) {

                    querySnapshot.forEach(async (doc) => {

                        let urlList = [];
                        let imgCount = 0;
                        let vidCount = 0;
                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {
                            isLoading: true,

                            id: doc.id,
                            idD: "",
                            userId: "",
                            fullName: "",
                            userName: "",
                            profilePic: "",
                            email: "",
                            bundle1: 0,
                            bundle2: 0,
                            bundle3: 0,

                            isOwner: false,
                            isSubscribed: false,
                            tags: "",
                            caption: "",
                            category: "",

                            timeStamp: doc.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: this.timeFormat(a1),

                            price: "",
                            previewUrl: "",
                            mediaList: "",

                            isLiked: false,
                            isBookmarked: false,

                            likeCount: "",
                            bookmarkCount: "",
                            commentCount: "",

                            toggler: false,
                            urlList: urlList,
                            imgCount: imgCount,
                            vidCount: vidCount,
                            previewUrl2: "",

                            postType: "",
                            isPaid: false,
                            priceD: "",
                            sexuality: "",
                            userType: ""

                        }

                        this.bookmarkList.push(result);

                        let mIndex = this.bookmarkList.length - 1;

                        await this.getFullBook( doc.id, mIndex);

                    })


                }


                return res.length;
                
                

            },

            async getOneBookmarkPost(postId){

                const postRef = doc(db, "UserPosts", postId);
                const postSnap = await getDoc(postRef);

                if(!postSnap.exists()){
                    return;
                }

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;
                let a1 = Number(postSnap.data().timeStamp.seconds) * 1000;
                let a2 = String(new Date(Number(postSnap.data().timeStamp.seconds) * 1000));

                let result = {
                            
                            isLoading: true,
                            id: postSnap.id,
                            idD: postSnap.data().idD,
                            userId: postSnap.data().userId,
                            fullName: postSnap.data().fullName,
                            userName: postSnap.data().username, 
                            
                            profilePic: postSnap.data().profilePic,
                            isOwner: false,
                            isSubscribed: false,
                            tags: postSnap.data().tags,
                            caption: postSnap.data().caption,
                            category: postSnap.data().category,

                            timeStamp: postSnap.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: this.timeFormat(a1),

                            price: postSnap.data().price,
                            previewUrl: postSnap.data().previewUrl,
                            mediaList: postSnap.data().mediaList,

                            isLiked: false,
                            isBookmarked: false,

                            likeCount: postSnap.data().likeCount,
                            bookmarkCount: postSnap.data().bookmarkCount,
                            commentCount: postSnap.data().commentCount,

                            toggler: false,
                            urlList: urlList,
                            imgCount: imgCount,
                            vidCount: vidCount,
                            previewUrl2: [postSnap.data().previewUrl],

                            postType: postSnap.data().postType,
                            isPaid: false,
                            priceD: Number(postSnap.data().price).toLocaleString("us-US")
                            
                            
                        }

                this.bookmarkList.push(result);
                let mIndex = this.bookmarkList.length - 1;
                this.getFullName(postSnap.id, postSnap.data().userId, postSnap.data().mediaList, postSnap.data().previewUrl, mIndex);

            },

            async getUserInfoPost(userId){

                let isOwner =false; 
                let isSubscribed = false; 
                let fanList =[];

                const auth = getAuth();

                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });

                //check if owner
                if(auth.currentUser.uid == userId){
                    isOwner = true;
                    isSubscribed = true;
                }
                else{
                    for(let i=0; i < fanList.length ; i++){
                        if(fanList[i] == auth.currentUser.uid){
                            isSubscribed = true;
                        }
                    }
                }

                return {
                    profilePic : userSnap.data().profilePic,
                    fullName: userSnap.data().name,
                    userName: userSnap.data().displayId,
                    email: userSnap.data().email,
                    userType : userSnap.data().type,
                    isOwner : isOwner,
                    isSubscribed: isSubscribed,
                }

            },

            async getLikedStatus(postId){

                let likedList = [];
                const auth = getAuth();

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "LikedList"));
                querySnapshot.forEach((doc) => {
                    likedList.push(doc.id);
                });

                for(let i=0; i < likedList.length ; i++){
                    if(likedList[i] == auth.currentUser.uid){
                        return true
                    }
                }

                return false;

            },

            async getBookmarkStatus(postId){

                const auth = getAuth();
                let bookmarkList = [];

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "BookmarkList"));
                querySnapshot.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                for(let i=0; i < bookmarkList.length ; i++){
                    if(bookmarkList[i] == auth.currentUser.uid){
                        return true
                    }
                }

                return false;

            },

            galleryBtnClick(post){

                this.mediaUrl = post.mediaList[0].url;
                this.mediaType = post.mediaList[0].type;
                this.modelUsername = post.userName;
                this.mediaList = post.mediaList;

            },

            playMedia(media){

                this.mediaName = media.name;
                this.mediaType = media.type;
                this.mediaUrl = media.url;
                this.mediaSize = media.size
                //this.$refs.showModal.classList.add("bg-active");

            },

            async likeClick(id, index, post){

                const auth = getAuth();
                this.likeSpamList.push(post.id);


                $("#"+id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
                $("#"+id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                //update list
                if(post.isLiked){
                    this.bookmarkList[index].likeCount--;
                    this.bookmarkList[index].isLiked = false;

                    if(this.getOccurrence(this.likeSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(-1),
                        
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(-1),
                        likesN: increment(1)
                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
                }

                else{
                    this.bookmarkList[index].likeCount++;
                    this.bookmarkList[index].isLiked = true;

                    if(this.getOccurrence(this.likeSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(1),
                        
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(1),
                        likesN: increment(-1)
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid),{
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if(post.userId != auth.currentUser.uid){

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime()/1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"),{
                            category: "Likes",
                            description: "Liked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            dateN: secs,
                            postId: post.id,
                        });

                    }
                }
                
            },

            async bookClick(id, index, post){

                $("#"+id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
                $("#"+id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                const auth = getAuth();
                this.bookSpamList.push(post.id);

                //update list
                if(post.isBookmarked){
                    this.bookmarkList[index].bookmarkCount--;
                    this.bookmarkList[index].isBookmarked = false;

                    if(this.getOccurrence(this.bookSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(-1),
                        
                    });

                    //remove bookmark post
                    await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id ));
                }

                else{
                    this.bookmarkList[index].bookmarkCount++;
                    this.bookmarkList[index].isBookmarked = true;

                    if(this.getOccurrence(this.bookSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(1),
                        
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    //add post to bookmark
                    await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid),{
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });
                    await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id),{
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    // NOTIFICATION
                    if(post.userId != auth.currentUser.uid){

                        const notiRef = doc(db, "Users", post.userId);
                        await updateDoc(notiRef, {
                            notiCount: increment(1),
                        });

                        let mSecs = new Date().getTime()/1000;
                        let secs = 10000000000 / mSecs

                        await addDoc(collection(db, "UserNoti"),{
                            category: "Bookmarks",
                            description: "Bookmarked your post",
                            ownerId: post.userId,
                            userId: auth.currentUser.uid,
                            username: sessionStorage.getItem("userName"),
                            fullName: sessionStorage.getItem("fullName"),
                            profilePic: sessionStorage.getItem("profilePic"),
                            email: sessionStorage.getItem("email"),
                            date: serverTimestamp(),
                            postId: post.id,
                            dateN: secs
                        });

                    }
                }
            },

            async commentClick(post, index){

                this.commentCount = post.commentCount;
                this.postId = post.id;
                this.cModelId = post.userId;
                this.postIndex = index;

                this.comments =[];
                this.commentInput ="";

                const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20));
                const querySnapshot = await getDocs(q);
                
                querySnapshot.forEach((doc) => {
                    this.comments.push({
                        userId: doc.data().userId,
                        profilePic: doc.data().profilePic,
                        name: doc.data().name,
                        userName: doc.data().userName,
                        comment: doc.data().comment,
                        date: doc.data().date,
                    });
                });

            },

            async postComment(){

                document.getElementById("commentBtn").disabled = true;
                this.commentCount++;
                const auth = getAuth();

                let a = String(new Date());

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                //update list
                let commentObj = {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                }

                this.comments.unshift(commentObj);
                document.getElementById("comDiv").scrollIntoView();
                
                //update post comment db
                const postRef = doc(db, "UserPosts", this.postId);
                await updateDoc(postRef, {
                    
                    commentCount: increment(1),

                });

                await addDoc(collection(db, "UserPosts", this.postId, "Comments"), {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                });

                
                document.getElementById("commentBtn").disabled = false;
                this.bookmarkList[this.postIndex].commentCount++;

                // NOTIFICATION
                if(this.cModelId != auth.currentUser.uid){

                    const notiRef = doc(db, "Users", this.cModelId);
                    await updateDoc(notiRef, {
                        notiCount: increment(1),
                    });

                    let mSecs = new Date().getTime()/1000;
                let secs = 10000000000 / mSecs

                    await addDoc(collection(db, "UserNoti"),{
                        category: "Comments",
                        description: "Commented on your post: "+this.commentInput,
                        ownerId: this.cModelId,
                        userId: auth.currentUser.uid,
                        username: sessionStorage.getItem("userName"),
                        fullName: sessionStorage.getItem("fullName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                        email: sessionStorage.getItem("email"),
                        date: serverTimestamp(),
                        postId: this.postId,
                        dateN: secs
                    });

                }

                this.commentInput = "";

            },
            
            async getFullName(id, userId, mediaList, previewUrl, mIndex){

                let i = mIndex;
                let fanList = [];
                let likedList = [];
                let bookmarkList = [];
                let paidUsers = [];

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;

                for (let a = 0; a < mediaList.length; a++) {
                    urlList.push(mediaList[a].url)
                    if (mediaList[a].type.startsWith("image")) {
                        imgCount++;
                    }
                    else if (mediaList[a].type.startsWith("video")) {
                        vidCount++;
                    }
                }

                if(mediaList.length < 1){
                    urlList.push(previewUrl);
                }

                const auth = getAuth();
                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });

                const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
                querySnapshot2.forEach((doc) => {
                    likedList.push(doc.id);
                });

                const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
                querySnapshot3.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                const querySnapshot4 = await getDocs(collection(db, "UserPosts", id, "PaidUsers"));
                querySnapshot4.forEach((doc) => {
                    paidUsers.push(doc.id);
                });

                if(this.bookmarkList[i].id == id){
                        
                        this.bookmarkList[i].fullName = userSnap.data().name;
                        this.bookmarkList[i].userName = userSnap.data().displayId;
                        this.bookmarkList[i].profilePic = userSnap.data().profilePic;

                        this.bookmarkList[i].urlList = urlList;
                        this.bookmarkList[i].vidCount = vidCount;
                        this.bookmarkList[i].imgCount = imgCount;

                        if(auth.currentUser.uid == userId){
                            this.bookmarkList[i].isOwner = true;
                            this.bookmarkList[i].isSubscribed = true;
                            this.bookmarkList[i].isPaid = true;
                        }
                        else if(userSnap.data().type == "user" || userSnap.data().profileType == "free"){
                            this.bookmarkList[i].isSubscribed = true;
                        }
                        else{
                            for(let b=0; b < fanList.length ; b++){
                                if(fanList[b] == auth.currentUser.uid){
                                    this.bookmarkList[i].isSubscribed = true;
                                    break;
                                }
                            }
                        }

                        for(let c=0; c < likedList.length ; c++){
                            if(likedList[c] == auth.currentUser.uid){
                                this.bookmarkList[i].isLiked = true;
                                break;
                            }
                        }

                        for(let d=0; d < bookmarkList.length ; d++){
                            if(bookmarkList[d] == auth.currentUser.uid){
                                this.bookmarkList[i].isBookmarked = true;
                                break;
                            }
                        }

                        for (let e = 0; e < paidUsers.length; e++) {
                            if (paidUsers[e] == auth.currentUser.uid) {
                                this.bookmarkList[i].isPaid = true;
                                break;
                            }
                        }

                        this.bookmarkList[i].isLoading = false;

                    }

                

            },

            async getFullBook( docId, index){

                const postRef = doc(db, "UserPosts", docId);
                const postSnap = await getDoc(postRef);

                if(!postSnap.exists()){
                    this.bookmarkList.splice(index, 1);
                    return;
                }

                let i = index;
                let fanList = [];
                let likedList = [];
                let bookmarkList = [];
                let paidUsers = [];

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;

                for (let a = 0; a < postSnap.data().mediaList.length; a++) {
                    urlList.push(postSnap.data().mediaList[a].url)
                    if (postSnap.data().mediaList[a].type.startsWith("image")) {
                        imgCount++;
                    }
                    else if (postSnap.data().mediaList[a].type.startsWith("video")) {
                        vidCount++;
                    }
                }

                if(postSnap.data().mediaList.length < 1){
                    urlList.push(postSnap.data().previewUrl);
                }

                const auth = getAuth();
                const userRef = doc(db, "Users", postSnap.data().userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", postSnap.data().userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });

                const querySnapshot2 = await getDocs(collection(db, "UserPosts", docId, "LikedList"));
                querySnapshot2.forEach((doc) => {
                    likedList.push(doc.id);
                });

                const querySnapshot3 = await getDocs(collection(db, "UserPosts", docId, "BookmarkList"));
                querySnapshot3.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                const querySnapshot4 = await getDocs(collection(db, "UserPosts", docId, "PaidUsers"));
                querySnapshot4.forEach((doc) => {
                    paidUsers.push(doc.id);
                });

                if(this.bookmarkList[i].id == docId){

                        
                        this.bookmarkList[i].userId = userSnap.data().userId;
                        this.bookmarkList[i].fullName = userSnap.data().name;
                        this.bookmarkList[i].userName = userSnap.data().displayId;
                        this.bookmarkList[i].profilePic = userSnap.data().profilePic;
                        this.bookmarkList[i].sexuality = userSnap.data().sexuality;
                        this.bookmarkList[i].userType = userSnap.data().type;

                        this.bookmarkList[i].urlList = urlList;
                        this.bookmarkList[i].vidCount = vidCount;
                        this.bookmarkList[i].imgCount = imgCount;

                        this.bookmarkList[i].idD = postSnap.data().idD;
                        this.bookmarkList[i].price = postSnap.data().price;
                        this.bookmarkList[i].caption = postSnap.data().caption;
                        this.bookmarkList[i].category = postSnap.data().category;
                        this.bookmarkList[i].previewUrl = postSnap.data().previewUrl;
                        this.bookmarkList[i].mediaList = postSnap.data().mediaList;
                        this.bookmarkList[i].likeCount = postSnap.data().likeCount;
                        this.bookmarkList[i].bookmarkCount = postSnap.data().bookmarkCount;
                        this.bookmarkList[i].commentCount = postSnap.data().commentCount;
                        this.bookmarkList[i].previewUrl2 = [postSnap.data().previewUrl];
                        this.bookmarkList[i].postType = postSnap.data().postType;
                        this.bookmarkList[i].priceD = Number(postSnap.data().price).toLocaleString("US-us");

                        if(auth.currentUser.uid == postSnap.data().userId){
                            this.bookmarkList[i].isOwner = true;
                            this.bookmarkList[i].isSubscribed = true;
                            this.bookmarkList[i].isPaid = true;
                        }
                        else if(userSnap.data().type == "user" || userSnap.data().profileType == "free"){
                            this.bookmarkList[i].isSubscribed = true;
                        }
                        else{
                            for(let b=0; b < fanList.length ; b++){
                                if(fanList[b] == auth.currentUser.uid){
                                    this.bookmarkList[i].isSubscribed = true;
                                    break;
                                }
                            }
                        }

                        for(let c=0; c < likedList.length ; c++){
                            if(likedList[c] == auth.currentUser.uid){
                                this.bookmarkList[i].isLiked = true;
                                break;
                            }
                        }

                        for(let d=0; d < bookmarkList.length ; d++){
                            if(bookmarkList[d] == auth.currentUser.uid){
                                this.bookmarkList[i].isBookmarked = true;
                                break;
                            }
                        }

                        for (let e = 0; e < paidUsers.length; e++) {
                            if (paidUsers[e] == auth.currentUser.uid) {
                                this.bookmarkList[i].isPaid = true;
                                break;
                            }
                        }

                        this.bookmarkList[i].isLoading = false;

                    }

            },

            async handleInfinite($state) {

                const newPostCount = await this.getBookmarkList();

                if (newPostCount > 0) {
                    //more posts
                    return $state.loaded();
                }

                if (this.bookmarkList.length == 0) {
                    document.getElementById("emptyAllBook").style.display = "flex";
                    document.getElementById("emptyAllBook").style.visibility = "visible";

                }

                //no more posts
                document.getElementById("emptyAllBook2").style.display = "none";

                //no more posts
                return $state.complete();

            },

        },

        
    }


</script>